/* global __WEB__ */

/**
 * Simple Redux middleware to enable communication with native app.
 *
 * The middleware works with WKWebView for iOS (version >= 8) and ... for Android (version >= ...).
 *
 * To pass messages to the
 *
 * This middleware ensures that all API actions sends an empty `headers` object if `headers` is
 * undefined.
 */
export default function appCommunicationMiddleware() {
    return (/* store */) => (next) => (action) => {
        if (action.type === '@@router/LOCATION_CHANGE') {
            if (window && window.webkit) {
                const payload = action.payload;
                payload.pathname = decodeURIComponent(payload.pathname);

                const message = JSON.stringify(payload);
                window.webkit.messageHandlers.locationChange.postMessage(message);
            }
        }

        return next(action);
    };
}



/** WEBPACK FOOTER **
 ** /src/shared/redux/middlewares/appCommunicationMiddleware.js
 **/